import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import AppLayout from '../layouts/AppLayout.vue';

import AuthLayout from '../layouts/AuthLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'news' },
  },
  {
    name: 'base',
    path: '/',
    component: AppLayout,
    redirect: { name: 'news' },
    children: [
      {
        name: 'settings',
        path: 'settings',
        component: () => import('@/pages/settings/Settings.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('@/pages/users/UsersPage.vue'),
      },
      {
        name: 'game',
        path: 'game',
        component: () => import('@/pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'logs',
        path: 'logs',
        component: () => import('@/pages/logsPage/LogsPage.vue'),
      },
      {
        name: 'news',
        path: 'news',
        component: () => import('@/pages/news/NewsPage.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: '',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes,
});

export default router;
